<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatTime } from '../../constants';

// "Atención": el estado de las conversaciones del período. Salen del mismo
// conjunto que el embudo, así que respetan equipo, fechas y los filtros por
// atributo de contacto.
const props = defineProps({
  attention: { type: Object, default: () => ({}) },
  avgClosingTime: { type: Number, default: 0 },
});

const { t, locale } = useI18n();
const key = 'OVERVIEW_REPORTS.ATTENTION';

const numberFormatter = computed(
  () => new Intl.NumberFormat(locale.value || 'es')
);

const rows = computed(() => {
  const attention = props.attention || {};
  return [
    {
      key: 'open',
      dot: 'bg-n-blue-9',
      label: t(`${key}.OPEN`),
      value: numberFormatter.value.format(attention.open || 0),
    },
    {
      key: 'unattended',
      dot: 'bg-n-ruby-9',
      label: t(`${key}.UNATTENDED`),
      value: numberFormatter.value.format(attention.unattended || 0),
      alert: (attention.unattended || 0) > 0,
    },
    {
      key: 'resolved',
      dot: 'bg-n-teal-9',
      label: t(`${key}.RESOLVED`),
      value: numberFormatter.value.format(attention.resolved || 0),
    },
    {
      key: 'closing',
      dot: 'bg-n-amber-9',
      label: t(`${key}.AVG_CLOSING`),
      value: props.avgClosingTime ? formatTime(props.avgClosingTime) : '—',
    },
  ];
});
</script>

<template>
  <section
    class="flex flex-col gap-3.5 px-4 py-3.5 border rounded-xl border-n-weak bg-n-solid-2"
  >
    <h5 class="mb-0 text-base font-semibold text-n-slate-12">
      {{ t(`${key}.HEADER`) }}
    </h5>
    <div class="flex flex-col gap-2.5">
      <div v-for="row in rows" :key="row.key" class="flex items-center gap-2.5">
        <span class="rounded-full size-1.5 flex-shrink-0" :class="row.dot" />
        <span class="flex-1 text-[13px] truncate text-n-slate-11">
          {{ row.label }}
        </span>
        <span
          class="text-[13px] font-semibold tabular-nums"
          :class="row.alert ? 'text-n-ruby-11' : 'text-n-slate-12'"
        >
          {{ row.value }}
        </span>
      </div>
    </div>
  </section>
</template>
